import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Reveal } from "./Reveal";
import { SacredGeometry } from "./SacredGeometry";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOPICS = ["Speaking & facilitation", "Writing & media", "The Liminal Womyn Podcast", "Collaboration", "Something else"];

export const Enquiry = () => {
  const [form, setForm] = useState({ name: "", email: "", topic: TOPICS[0], message: "" });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiry`, form);
      toast.success("Enquiry sent — Rachelle will be in touch soon.");
      setForm({ name: "", email: "", topic: TOPICS[0], message: "" });
    } catch (err) {
      toast.error("Something went wrong sending your enquiry. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="enquire" data-testid="enquiry-section" className="relative bg-royal py-28 md:py-36 overflow-hidden">
      <SacredGeometry variant="flower" className="right-[-4rem] top-[-3rem] w-96 opacity-10" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-16">
        <Reveal>
          <p className="eyebrow text-gold">Enquiries</p>
          <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-tight mt-6 text-cream">
            Let's connect and <span className="italic text-gold">create change</span> together
          </h2>
          <p className="mt-8 max-w-md text-cream/70 text-base leading-relaxed">
            Ready to explore new possibilities, drive impactful change, or embark on a journey
            of self-discovery? Send an enquiry and it lands directly in Rachelle's inbox.
          </p>
          <div className="mt-12 space-y-4 text-sm">
            <p className="text-cream/70">Email — <a href="mailto:rachelle@sustainify.com.au" data-testid="contact-email-link" className="text-gold hover:text-cream transition-colors">rachelle@sustainify.com.au</a></p>
            <p className="text-cream/70">Phone — <a href="tel:+61416718407" data-testid="contact-phone-link" className="text-gold hover:text-cream transition-colors">0416 718 407</a></p>
            <p className="text-cream/70">LinkedIn — <a href="https://www.linkedin.com/in/rachellecooperkulkarni/" target="_blank" rel="noopener noreferrer" data-testid="contact-linkedin-link" className="text-gold hover:text-cream transition-colors">linkedin.com/in/rachellecooperkulkarni</a></p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <form onSubmit={submit} className="space-y-8" data-testid="enquiry-form">
            <div>
              <label htmlFor="enquiry-name" className="eyebrow text-cream/60">Your name</label>
              <input id="enquiry-name" data-testid="enquiry-name-input" required className="field mt-2"
                placeholder="Jane Citizen" value={form.name} onChange={set("name")} maxLength={120} />
            </div>
            <div>
              <label htmlFor="enquiry-email" className="eyebrow text-cream/60">Your email</label>
              <input id="enquiry-email" data-testid="enquiry-email-input" required type="email" className="field mt-2"
                placeholder="jane@example.com" value={form.email} onChange={set("email")} />
            </div>
            <div>
              <label htmlFor="enquiry-topic" className="eyebrow text-cream/60">What's this about?</label>
              <select id="enquiry-topic" data-testid="enquiry-topic-select" className="field mt-2" value={form.topic} onChange={set("topic")}>
                {TOPICS.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            <div>
              <label htmlFor="enquiry-message" className="eyebrow text-cream/60">Your message</label>
              <textarea id="enquiry-message" data-testid="enquiry-message-input" required rows={5} className="field mt-2 resize-none"
                placeholder="Tell me what you're dreaming up…" value={form.message} onChange={set("message")} maxLength={4000} />
            </div>
            <button type="submit" data-testid="enquiry-submit-button" disabled={sending}
              className="eyebrow bg-gold text-ink px-8 py-4 rounded-full hover:bg-cream transition-colors duration-300 disabled:opacity-50 disabled:cursor-not-allowed">
              {sending ? "Sending…" : "Send enquiry"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
